import { useMemo } from 'react';

import PropTypes from 'prop-types';

import CarouselComponent from './CarouselComponent';

const ExpandableImageComponent = (props) => {
  const {
    src, // just a url if there is no photo obj
    photo, // photo obj with thumbnail and original photo urls
    caption,
    name,
    isSquare,
    isClickable,
    height,
    width,
  } = props;

  const { url, thumbnailUrl } = photo || {};

  const image = useMemo(
    () => [
      {
        source: {
          regular: url || src,
          fullscreen: url || src,
          thumbnail: thumbnailUrl || url || src,
        },
        caption,
        author: { url: null, name },
      },
    ],
    [url, src, thumbnailUrl],
  );
  return (
    <CarouselComponent
      images={image}
      isSquare={isSquare}
      isClickable={isClickable}
      height={height}
      width={width}
    />
  );
};

ExpandableImageComponent.propTypes = {
  src: PropTypes.string,
  photo: PropTypes.instanceOf(Object),
  height: PropTypes.string,
  width: PropTypes.string,
  caption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.number,
    PropTypes.node,
  ]),
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.number,
    PropTypes.node,
  ]),
  isSquare: PropTypes.bool,
  isClickable: PropTypes.bool,
};

export default ExpandableImageComponent;
